export default "__VITE_ASSET__d68a0638__"